var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isView)?_c('div',{staticClass:"diceBotMessageText",class:[_vm.animationClass, _vm.colorClass],attrs:{"title":"閉じる"},domProps:{"innerHTML":_vm._s(_vm.viewMessage)},on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }